import { typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { localize } from 'common/utils';
import { WOLT_SPECIALS_CATEGORY_ID } from 'modules/menu/items/constants';
import { getItemCategory } from 'modules/menu/items/utils';
import useMenuData from 'modules/menu/useMenuData';

type Props = {
  language: Language;
  optionId: string;
};

const Root = styled.div``;

const Header = styled.div`
  ${typographyCss.Title1()};
  padding: 8px 0;
`;

const EmptyList = styled.div`
  ${typographyCss.Body3()};
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const ItemLink = styled.a`
  ${typographyCss.Body3()};
`;

const ItemLinks = ({ language, optionId }: Props) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const { items, categories } = useMenuData();

  // takes the slug directly from pathname. Ex.: '/venue/mama-pizza' -> slug = 'mama-pizza'
  const [, , venueSlug]: (string | undefined)[] = pathname.split('/');

  if (!venueSlug) {
    return null;
  }

  const itemsLinkingToOption = items.filter(item => !!item.option_bindings.find(ob => ob.option_id === optionId));

  const regularItemsLinkingToOption = itemsLinkingToOption.filter(item => {
    const category = getItemCategory(categories, item.id);
    return !(category && category.id === WOLT_SPECIALS_CATEGORY_ID);
  });
  const specialsLinkingToOption = itemsLinkingToOption.filter(item => {
    const category = getItemCategory(categories, item.id);
    return !!category && category.id === WOLT_SPECIALS_CATEGORY_ID;
  });

  const numberOfLinkedItems = regularItemsLinkingToOption.length + specialsLinkingToOption.length;

  return (
    <Root>
      <Header>
        <FormattedMessage id="menu-option.links-header" /> ({numberOfLinkedItems})
      </Header>
      {numberOfLinkedItems === 0 ? (
        <EmptyList>
          <FormattedMessage id="menu-option.no-links" />
        </EmptyList>
      ) : (
        <List>
          {regularItemsLinkingToOption.map(item => (
            <ItemLink
              key={item.id}
              onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                event.stopPropagation();
                history.push(`/venue/${venueSlug}/menu-editor?item=${item.id}`);
              }}
            >
              {localize(item.name, language)}
            </ItemLink>
          ))}
          {specialsLinkingToOption.map(item => (
            <ItemLink
              key={item.id}
              onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                event.stopPropagation();
                history.push(`/venue/${venueSlug}/menu-editor?item=${item.id}`);
              }}
            >
              {localize(item.name, language)} (Wolt Special)
            </ItemLink>
          ))}
        </List>
      )}
    </Root>
  );
};

export default ItemLinks;
